import { render } from "./Button.vue?vue&type=template&id=76eed1f1&ts=true"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__